import SubmitButton from './SubmitButton';
import CloseButton from './CloseButton';

export {
    SubmitButton,
    CloseButton
};
